import React from 'react'

export default function BrowserOnly({ children }: { children: React.ReactNode }): React.ReactNode {
  const [isMounted, setIsMounted] = React.useState(false)

  React.useEffect(() => {
    setIsMounted(true)
  }, [])

  return isMounted ? children : null
}
